const directive = {
  mounted(el) {
    el.focus();
  }
};
export {
  directive as default
};
//# sourceMappingURL=index.mjs.map
